import { createI18n, type LocaleCode } from "@orvis/i18n";

/**
 * Boot i18next once for the current browser session.
 *
 * The country config's default locale is authoritative — a Costa Rica
 * build always starts in Spanish, a China build always starts in
 * English, regardless of the device/browser locale. There's no
 * in-app language switcher, so letting the browser locale win here
 * (the previous behavior) meant any non-Spanish device silently showed
 * an English CR app.
 */
export function bootI18n(defaultLanguage: LocaleCode) {
  return createI18n({ language: defaultLanguage, defaultLanguage });
}
